import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { getFirestore, collection } from 'firebase/firestore'
import { getStorage, ref as storageRef } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

const firebaseConfig = {
  apiKey: 'AIzaSyAzQxHkc8FbWk1csFgsTUqealIHqxtPkHM',
  authDomain: 'smnc-efcb3.firebaseapp.com',
  databaseURL: 'https://smnc-efcb3.firebaseio.com',
  projectId: 'smnc-efcb3',
  storageBucket: 'smnc-efcb3.appspot.com',
  messagingSenderId: '6667197631',
  appId: '1:6667197631:web:abe053938734c25a78ba0a',
  measurementId: 'G-P1SX2HQ7PE',
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const auth = getAuth(app)
const functions = getFunctions(app)
const storage = getStorage(app)
const sigs = storageRef(storage, 'votes/signatures/')

const usersCollection = collection(db, 'users')
const votesCollection = collection(db, 'votes')
const shn = collection(db, 'shn')
const mail = collection(db, 'mail')
const meetingsCollection = collection(db, 'meetings')
const ballotsCollection = collection(db, 'ballots')

// Resolves once the initial auth state has been determined (user or null).
// Used by the router guard to avoid redirecting to /login during the initial
// page load race.
let authReadyResolve
const authReady = new Promise((resolve) => {
  authReadyResolve = resolve
})
onAuthStateChanged(auth, (user) => {
  authReadyResolve(user)
})

export {
  app,
  db,
  auth,
  authReady,
  functions,
  storage,
  sigs,
  shn,
  mail,
  usersCollection,
  votesCollection,
  meetingsCollection,
  ballotsCollection,
}
